(function () {
    var AddClientCtrl = (function () {
        function AddClientCtrl() {
            this.init.apply(this, arguments);
        }

        AddClientCtrl.prototype = {
            /**
             * 
             * @param $scope
             * @param $mdDialog
             * @param MKioskService
             * @param mdPanelRef
             * @param $timeout
             * @param client
             * @param prevRouter
             * @param onClose
             * @param DeviceService{DeviceService}
             */
            init: function ($scope, $mdDialog, MKioskService, mdPanelRef, $timeout, client, prevRouter, onClose, DeviceService) {
                $scope.vm = this;
                this.$scope = $scope;
                this.$mdDialog = $mdDialog;
                this.MKioskService = MKioskService;
                this.mdPanelRef = mdPanelRef;
                this.$timeout = $timeout;
                this.client = _.clone(client) || {
                    isTemporary: true
                };
                this.prevRouter = prevRouter;
                this.onClose = onClose;

                // NF-819: Prevent fire  backbutton to clients screen to fix issue clients screen is closed if press backbutton
                DeviceService.preventBackButton($scope);
            },
            goBack: function () {
                this.close();
            },
            submit: function () {
                if (this.prevRouter !== "clients") {
                    this.$mdDialog.hide(this.client);
                }
                this.close(this.client);
            },
            close(client){
                this.mdPanelRef.close().then(()=>{
                    this.onClose(client);
                    this.$scope.$destroy(); // Have to destroy $scope when panel is closed
                });
            }
        };
        AddClientCtrl.$inject = ['$scope', '$mdDialog', 'MKioskService', 'mdPanelRef', '$timeout', 'client', 'prevRouter', 'onClose', 'DeviceService'];
        return AddClientCtrl;
    }());
    angular.module('internal.addclient-v2', []).controller('AddClientV2Ctrl', AddClientCtrl);
})();